module.exports = __webpack_public_path__ + "components/weather-icon/static/daycloud-20afeb8abe34916ffbd46863ba209cf3.png";